<template>
  <analytics-sub-page
    title="Loans Analytics"
    icon="hand-holding-dollar"
    css-class="analytics-loans"
    default-label="Loans"
    :section-specs="sectionSpecs"
  >
    <sdl-metrics ref="sdlRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import SdlMetrics from '@/pages/analyticsApp/components/SdlMetrics.vue';

const sdlRef = ref(null);

// SdlMetrics renders two logical subsections: the over-time "Loans" chart and
// the "Loan details" stat row (average amount and loan purpose). Each spec
// scopes capture to the matching `data-pdf-section` marker.
const sectionFor = (sectionKey, hasDataKey, exportTableKey) => ({
  hasData: () => !!sdlRef.value?.[hasDataKey],
  getContainerEl: () => sdlRef.value?.$el?.querySelector(`[data-pdf-section="${sectionKey}"]`) || sdlRef.value?.$el,
  getExportTable: () => sdlRef.value?.[exportTableKey]?.() ?? null,
});

const sectionSpecs = [
  { key: 'loans', label: 'Loans issued', ...sectionFor('loans', 'hasLoansData', 'getLoansExportTable') },
  { key: 'details', label: 'Loan details', ...sectionFor('details', 'hasDetailsData', 'getDetailsExportTable') },
];
</script>
